import { render } from "./Scroller.vue?vue&type=template&id=8c8f46ee&ts=true"
import script from "./Scroller.vue?vue&type=script&lang=ts"
export * from "./Scroller.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__